import { useOperatorsClientsAllQuery } from '@/api/queries/operators';
import { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ControlledField, SelectInputField } from 'remote/global';

function SupplierSelectField({
  form,
  isOptional,
}: {
  form: UseFormReturn<any>; // TODO: FIX THIS TYPING
  isOptional?: boolean;
}) {
  const { control } = form;
  const [isClientsAllQueryEnabled, setIsClientsAllQueryEnabled] = useState(false);
  const { data: compactOptions } = useOperatorsClientsAllQuery(isClientsAllQueryEnabled);

  const options =
    compactOptions?.map((supplier) => ({ label: supplier.value, value: supplier.id })) ?? [];

  const handleToggleQuery = () => {
    // Hack to trigger enabled from false to true
    setIsClientsAllQueryEnabled(false);
    setTimeout(() => {
      setIsClientsAllQueryEnabled(true);
    }, 1);
  };

  return (
    <ControlledField
      control={control}
      name='clientId'
      render={(renderProps) => {
        // Makes sure to fetch the options if a defaultValue is set
        const loadInitialOptions =
          typeof renderProps.field.value === 'string'
            ? renderProps.field.value.length > 0 && options.length <= 0
            : renderProps.field.value != null && options.length <= 0;
        if (loadInitialOptions) handleToggleQuery();

        return (
          <SelectInputField
            {...renderProps}
            {...(isOptional && { translationKey: 'clientIdOptional' })}
            fieldProps={{ onFocus: handleToggleQuery }}
            options={options}
          />
        );
      }}
    />
  );
}

export default SupplierSelectField;
